import { HomeOutlined, UserOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Form, Input, Table, Radio, Select, InputNumber, Modal, Spin, Space, Tooltip } from 'antd';
import './sales_estimation.css';
import { SalesMasterData, useSalesEstimation } from '../../components/hoc_sales';
import SalesDataCustomer from './sales_data_customer';
import SalesAddLine from './sales_add_line';
import { useAuth } from "../../context/AuthContext";
import CloseOrder from './close_order';
import BrowserAgreementSales from './browser_agreement_sales';
import { LoadingOutlined, CheckCircleOutlined, StopOutlined, WarningOutlined } from '@ant-design/icons';
import { FaPlusCircle } from 'react-icons/fa';
import { IoPrintSharp } from 'react-icons/io5';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import { RiFileCloseFill } from 'react-icons/ri';
import { HiOutlineDocumentCheck } from 'react-icons/hi2';
interface SalesEstimationProps {
    editData?: any;
}

const SalesEstimation: React.FC<SalesEstimationProps> = ({ editData }) => {
    const {
        isCheckedCustomerDetail,
        isCheckedSameID,
        handleCustomerDetail,
        handleSameID,
        rowSelection,
        columns,
        tableData,
        loading,
        error,
        deliverVia,
        handleDeliverViaChange,
        deliverViaOptions,
        warehouseGroup,
        outstandingRemark,
        handleOutstandingRemarkChange,
        outstandingRemarkOptions,
        orderTypeOptions,
        handleOrderTypeChange,
        orderType,
        transTypeOptions,
        handleTransTypeChange,
        transType,
        TopOptions,
        handleTopChange,
        Top,
        form,
        isCustomerModalVisible,
        handleCustomerModalOpen,
        handleCustomerModalClose,
        handleCustomerSelect,
        handleCustomerCodeBlur,
        handleNew,
        isAddLineModalVisible,
        handleAddLineModalOpen,
        handleAddLineModalClose,
        handleAddLineSubmit,
        handleRowDoubleClick,
        editingData,
        handleDelete,
        selectedRowKeys,
        isStatus01,
        isReadyButtonDisabled,
        isNotAvailableButtonDisabled,
        handleNotAvailable,
        handleReady,
        handleCloseOrderModalOpen,
        handleCloseOrderModalClose,
        isCloseOrderModalVisible,
        setIsCloseOrderModalVisible,
        isCloseOrderDisabled,
        isSubmitDisabled,
        isVoidDisabled,
        handleSubmit,
        handleVoid,
        isAgreementModalVisible,
        handleAgreementModalOpen,
        handleAgreementModalClose,
        handleAgreementSelect,
        initialDiscForAddLine: currentAgreementDisc,
        addLineModalKey,
        isActuallyEditing,
        isLockItemDisabled,
        handleLockItem,
        handleWarehouseGroupChange,
        warehouseGroupOptions,
        autosaveStatus,
        isPrintButtonDisabled,
        handlePrint,
        isPrinting,
        isReportModalOpen,
        handleReportModalCancel,
        status,
        handleFormChange,
        isSubmitModalVisible,
        submitRemark,
        setSubmitRemark,
        handleConfirmSubmit,
        handleSubmitModalClose,
        overallLoading
    } = useSalesEstimation(editData);
    const Printbtn = IoPrintSharp as React.ComponentType<any>;
    const Voidbtn = IoIosCloseCircleOutline as React.ComponentType<any>;
    const Closebtn = RiFileCloseFill as React.ComponentType<any>;
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;
    const { userData } = useAuth();
    const seNo = form.getFieldValue('se_no')
    const soNo = form.getFieldValue('so_no')

    return (
        <Spin spinning={overallLoading} size="large" tip="Loading Load Data...">
            <div
                id="iau999999938"
                style={{
                    transform: 'scale(0.80)',
                    transformOrigin: 'top left',
                    width: '125%'
                }}
            >
                <div className="gjs-grid-row" id="if4zx">
                    <div className="gjs-grid-column" id="ikz6x">
                        <Breadcrumb
                            items={[
                                {
                                    title: <HomeOutlined />
                                },
                                {
                                    href: '#/dashboard/sales_browser',
                                    title: (
                                        <>
                                            <span>Data Sales Master</span>
                                        </>
                                    )
                                },
                                {
                                    title: (
                                        <>
                                            <span style={{ fontWeight: '200', color: 'rgba(0, 0, 0, 0.88)' }}>Sales Master</span>
                                        </>
                                    )
                                },
                            ]}
                        />
                    </div>
                </div>

                <div className="gjs-grid-row" id="id977">
                    <div className="gjs-grid-column" id="i5nxl">
                        <Button className="gr-button" onClick={handleNew} disabled={autosaveStatus === 'processing'}>
                            <FaPlusCircle style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            New
                        </Button>
                        <Button className="gr-button" onClick={handleSubmit} disabled={isSubmitDisabled()}>
                            <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Submit
                        </Button>
                        <Button className="gr-button" onClick={() => {
                            Modal.confirm({
                                title: 'Konfirmasi Void',
                                content: 'Apakah anda yakin untuk melakukan Void?',
                                okText: 'Ya',
                                cancelText: 'Batal',
                                onOk: () => handleVoid(),
                            });
                        }} disabled={isVoidDisabled()}>
                            <Voidbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Void
                        </Button>
                        <Button className="green-button"
                            onClick={() => {
                                Modal.confirm({
                                    title: 'Konfirmasi Penutupan Order',
                                    content: 'Apakah anda yakin untuk menutup order?',
                                    okText: 'Ya',
                                    cancelText: 'Batal',
                                    onOk: () => handleCloseOrderModalOpen(),
                                });
                            }}
                            disabled={isCloseOrderDisabled()}
                        >
                            <Closebtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Close Order
                        </Button>
                        <Button className="gr-button" onClick={handlePrint} disabled={isPrintButtonDisabled} loading={isPrinting}>
                            <Printbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Print
                        </Button>
                        <Space style={{ marginLeft: '10px' }}>
                            {autosaveStatus === 'processing' && (
                                <Tooltip title="Autosave sedang berjalan...">
                                    <LoadingOutlined style={{ color: '#1890ff' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'error' && (
                                <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                    <WarningOutlined style={{ color: '#ff4d4f' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'stopped' && (
                                <Tooltip title="Autosave dihentikan karena status dokumen tidak 'Draft' atau data utama belum lengkap.">
                                    <StopOutlined style={{ color: '#bfbfbf' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'idle' && (
                                <Tooltip title="Autosave berhasil.">
                                    <CheckCircleOutlined style={{ color: '#52c41a' }} />
                                </Tooltip>
                            )}
                        </Space>
                    </div>
                </div>
                {/* Row 3 */}
                <div className="gjs-grid-row" id="idb6b">
                    <div className="gjs-grid-column" id="ipvl3">
                        <Form
                            form={form}
                            onValuesChange={handleFormChange}
                            layout="horizontal"
                            style={{ maxWidth: 550 }}
                            labelCol={{ style: { width: '200px' } }}
                            wrapperCol={{ style: { width: '290px' } }}
                            className="custom-info-so_next"

                        >
                            <Form.Item label="Status" name="status">
                                <Input className="input-detail-cs" placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Sales Estimation No" name="se_no">
                                <Input className="input-detail-cs" placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Sales Date" name="sales_date">
                                <Input className="input-detail-cs" placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Sales Order No." name="so_no">
                                <Input className="input-detail-cs" placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Transaction Type"
                                name="trans_type"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Required!',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select Transaction Type"
                                    optionFilterProp="label"
                                    onChange={handleTransTypeChange}
                                    value={transType}
                                    options={transTypeOptions}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Order Type"
                                name="order_type"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Required!',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select Order Type"
                                    optionFilterProp="label"
                                    onChange={handleOrderTypeChange}
                                    value={orderType}
                                    options={orderTypeOptions}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                    disabled={!isStatus01()}
                                />
                            </Form.Item>
                            <Form.Item label="Customer Code" style={{ marginBottom: 0 }} >
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Form.Item name="cs_code" style={{ width: '100px', marginRight: '8px' }}>
                                        <Input placeholder="Code"
                                            onBlur={handleCustomerCodeBlur}
                                        />
                                    </Form.Item>

                                    <Button name="modal_cs" type="primary" className="icon-button" style={{ margin: '0px' }} onClick={handleCustomerModalOpen}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="icon">
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path
                                                fillRule="evenodd"
                                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                clipRule="evenodd"
                                            />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>
                                    </Button>

                                    <Form.Item name="cs_name" style={{ flex: 1, marginLeft: '8px' }}>
                                        <Input placeholder="Name" />
                                    </Form.Item>
                                </div>
                            </Form.Item>
                            <Form.Item label="Customer Detail">
                                <Radio checked={isCheckedCustomerDetail} onClick={handleCustomerDetail}>
                                    Show
                                </Radio>
                            </Form.Item>
                            <div className={`fade-in ${isCheckedCustomerDetail ? 'show' : ''}`}>
                                {isCheckedCustomerDetail && (
                                    <Form.Item label="Title Prefix" name="title_prefix">
                                        <Input className="input-detail-cs" placeholder="" readOnly />
                                    </Form.Item>
                                )}
                            </div>
                            <div className={`fade-in ${isCheckedCustomerDetail ? 'show' : ''}`}>
                                {isCheckedCustomerDetail && (
                                    <Form.Item label="Customer Name" name="customer_name">
                                        <Input className="input-detail-cs" placeholder="" readOnly />
                                    </Form.Item>
                                )}
                            </div>
                            <div className={`fade-in ${isCheckedCustomerDetail ? 'show' : ''}`}>
                                {isCheckedCustomerDetail && (
                                    <Form.Item label="Title Suffix" name="title_suffix">
                                        <Input className="input-detail-cs" placeholder="" readOnly />
                                    </Form.Item>
                                )}
                            </div>
                            <div className={`fade-in ${isCheckedCustomerDetail ? 'show' : ''}`}>
                                {isCheckedCustomerDetail && (
                                    <Form.Item
                                        label="Address"
                                        style={{ marginBottom: "5px" }}
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                            <Form.Item
                                                name="cs_address1"
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Input className="input-detail-cs" placeholder="" style={{ width: '100%' }} readOnly />
                                            </Form.Item>

                                            <Form.Item
                                                name="cs_address2"
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Input className="input-detail-cs" placeholder="" style={{ width: '100%' }} readOnly />
                                            </Form.Item>
                                        </div>
                                    </Form.Item>
                                )}
                            </div>
                            <div className={`fade-in ${isCheckedCustomerDetail ? 'show' : ''}`}>
                                {isCheckedCustomerDetail && (
                                    <Form.Item label="Provinsi" name="cs_provinsi">
                                        <Input className="input-detail-cs" placeholder="" readOnly />
                                    </Form.Item>
                                )}
                            </div>
                            <div className={`fade-in ${isCheckedCustomerDetail ? 'show' : ''}`}>
                                {isCheckedCustomerDetail && (
                                    <Form.Item label="Kabupaten" name="cs_kabupaten">
                                        <Input className="input-detail-cs" placeholder="" readOnly />
                                    </Form.Item>
                                )}
                            </div>
                            <div className={`fade-in ${isCheckedCustomerDetail ? 'show' : ''}`}>
                                {isCheckedCustomerDetail && (
                                    <Form.Item label="Kecamatan" name="cs_kecamatan">
                                        <Input className="input-detail-cs" placeholder="" readOnly />
                                    </Form.Item>
                                )}
                            </div>
                            <div className={`fade-in ${isCheckedCustomerDetail ? 'show' : ''}`}>
                                {isCheckedCustomerDetail && (
                                    <Form.Item label="Kelurahan" name="cs_kelurahan">
                                        <Input className="input-detail-cs" placeholder="" readOnly />
                                    </Form.Item>
                                )}
                            </div>
                            <div className={`fade-in ${isCheckedCustomerDetail ? 'show' : ''}`}>
                                {isCheckedCustomerDetail && (
                                    <Form.Item label="Kode Pos" name="cs_kodepos">
                                        <Input className="input-detail-cs" placeholder="" readOnly />
                                    </Form.Item>
                                )}
                            </div>
                            <div className={`fade-in ${isCheckedCustomerDetail ? 'show' : ''}`}>
                                {isCheckedCustomerDetail && (
                                    <Form.Item label="Mobile Phone" name="cs_phone">
                                        <Input className="input-detail-cs" placeholder="" readOnly />
                                    </Form.Item>
                                )}
                            </div>
                            <div className={`fade-in ${isCheckedCustomerDetail ? 'show' : ''}`}>
                                {isCheckedCustomerDetail && (
                                    <Form.Item label="Mobile Phone 2" name="cs_phone1">
                                        <Input className="input-detail-cs" placeholder="" readOnly />
                                    </Form.Item>
                                )}
                            </div>
                            <div className={`fade-in ${isCheckedCustomerDetail ? 'show' : ''}`} style={{ paddingBottom: isCheckedCustomerDetail ? '20px' : '0px' }}>
                                {isCheckedCustomerDetail && (
                                    <Form.Item label="NPWP" name="cs_npwp">
                                        <Input className="input-detail-cs" placeholder="" readOnly />
                                    </Form.Item>
                                )}
                            </div>

                            <Form.Item label="Purchase Order No." name="purchase_order_no"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Required!',
                                    },
                                ]}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item
                                label="TOP"
                                name="top"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Required!',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select TOP"
                                    optionFilterProp="label"
                                    onChange={handleTopChange}
                                    value={Top}
                                    options={TopOptions}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item label="Agreement No.">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Form.Item name="agreement_no" style={{ width: '200px', marginRight: '8px' }}>
                                        <Input placeholder="Code" />
                                    </Form.Item>

                                    <Button id="browser_agreement" type="primary" className="icon-button" style={{ margin: '0px' }}
                                        onClick={handleAgreementModalOpen}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="icon">
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path
                                                fillRule="evenodd"
                                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                clipRule="evenodd"
                                            />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>
                                    </Button>
                                    <Form.Item name="disc_agreement" style={{ width: '50px', marginRight: '8px', marginLeft: '10px', display: 'none' }}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                </div>
                            </Form.Item>
                            <Modal
                                title="Select Customer"
                                open={isCustomerModalVisible}
                                onCancel={handleCustomerModalClose}
                                width={"max-content"}
                                footer={null}
                            >
                                <SalesDataCustomer onSelect={handleCustomerSelect} />
                            </Modal>
                            <Modal
                                title={editingData ? "Edit Order Item Detail" : "Add Order Item Detail"}
                                open={isAddLineModalVisible}
                                onCancel={handleAddLineModalClose}
                                width={500}
                                footer={null}
                                className="sales-add-line-modal"
                            >
                                <div className="sales_add_line-wrapper">
                                    <SalesAddLine
                                        key={addLineModalKey}
                                        onSubmit={handleAddLineSubmit}
                                        editData={editingData}
                                        onCancel={handleAddLineModalClose}
                                        initialDiscPercent={currentAgreementDisc}
                                    />
                                </div>
                            </Modal>
                            <Modal
                                title="Close Order"
                                open={isCloseOrderModalVisible}
                                onCancel={handleCloseOrderModalClose}
                                width={500}
                                footer={null}
                            >
                                <CloseOrder
                                    onClose={handleCloseOrderModalClose}
                                    seNo={form.getFieldValue('se_no')}
                                />
                            </Modal>
                            <Modal
                                title="Select Agreement"
                                open={isAgreementModalVisible}
                                onCancel={handleAgreementModalClose}
                                width={1200}
                                footer={null}
                            >
                                <BrowserAgreementSales onSelectAgreement={(agreementNo) => {
                                    form.setFieldsValue({ agreement_no: agreementNo });
                                    handleAgreementModalClose();
                                }} />
                            </Modal>
                            <Modal
                                title="Submit Approval Remark"
                                open={isSubmitModalVisible}
                                onOk={handleConfirmSubmit}
                                onCancel={handleSubmitModalClose}
                                okText="Submit"
                                cancelText="Batal"
                            >
                                <Input.TextArea
                                    rows={3}
                                    placeholder="Masukkan remark persetujuan..."
                                    value={submitRemark}
                                    onChange={(e) => setSubmitRemark(e.target.value)}
                                />
                            </Modal>
                            <Modal 
                                title="Print Preview - Sales Order" 
                                open={isReportModalOpen} 
                                onCancel={handleReportModalCancel} 
                                footer={null} 
                                width={1100} 
                                destroyOnClose 
                            > 
                                <div id="sti-viewer-container" style={{ width: '100%', minHeight: '75vh' }} /> 
                            </Modal>
                        </Form>
                    </div>
                    <div className="gjs-grid-column" id="ivfks">
                        <Form
                            form={form}
                            onValuesChange={handleFormChange}
                            layout="horizontal"
                            style={{ maxWidth: 550 }}
                            labelCol={{ style: { width: '200px' } }}
                            wrapperCol={{ style: { width: '290px' } }}
                            className="custom-info-so_next2"

                        >
                            <Form.Item label="Same as ID Address">
                                <Radio checked={isCheckedSameID} onClick={handleSameID}>
                                    Yes
                                </Radio>
                            </Form.Item>
                            <Form.Item
                                label="Address"
                                style={{ marginBottom: "5px" }}

                            >
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <Form.Item
                                        name="delivery_address1"
                                        noStyle
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Required!',
                                            },
                                        ]}
                                    >
                                        <Input placeholder="Address Line 1" style={{ width: '100%' }} />
                                    </Form.Item>
                                    <Form.Item
                                        name="delivery_address2"
                                        noStyle
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Required!',
                                            },
                                        ]}
                                    >
                                        <Input placeholder="Address Line 2" style={{ width: '100%' }} />
                                    </Form.Item>
                                </div>
                            </Form.Item>
                            <Form.Item label="Contact Person" name="contact_person"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Required!',
                                    },
                                ]}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item label="Contact Phone No" name="contact_phone"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Required!',
                                    },
                                ]}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item
                                label="Deliver Via"
                                name="deliver_via"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Required!',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select Deliver Via"
                                    optionFilterProp="label"
                                    onChange={handleDeliverViaChange}
                                    value={deliverVia}
                                    options={deliverViaOptions}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Warehouse"
                                name="warehouse_group"
                                style={{
                                    marginBottom: "5px",
                                }}
                                help={!userData?.warehouse_code ? "Warehouse belum terdefinisi di database user" : ""}
                                validateStatus={!userData?.warehouse_code ? "warning" : ""}
                            >
                                {userData && userData.warehouse_code ? (
                                    <Select
                                        showSearch
                                        placeholder="Select Warehouse"
                                        optionFilterProp="label"
                                        onChange={handleWarehouseGroupChange}
                                        value={warehouseGroup}
                                        options={warehouseGroupOptions}
                                        style={{ width: "100%" }}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        disabled={true}
                                    />
                                ) : (
                                    <Input
                                        placeholder="Warehouse belum terdefinisi di database user"
                                        readOnly
                                    />
                                )}
                            </Form.Item>
                            <Form.Item label="Approval Remark" name="approval_remark">
                                <Input.TextArea placeholder="Enter your remark" rows={2} readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Outstanding Remark"
                                name="outstanding_remark"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Required!',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select Outstanding Remark"
                                    optionFilterProp="label"
                                    onChange={handleOutstandingRemarkChange}
                                    value={outstandingRemark}
                                    options={outstandingRemarkOptions}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                        </Form>
                    </div>
                </div>

                <div className="gjs-grid-row" id="idb6b">
                    <div className="gjs-grid-column" id="ipvl3">
                        <Form
                            form={form}
                            onValuesChange={handleFormChange}
                            layout="horizontal"
                            style={{ maxWidth: 550, paddingTop: '20px' }}
                            labelCol={{ style: { width: '200px' } }}
                            wrapperCol={{ style: { width: '290px' } }}
                            className="custom-info-so_next3"

                        >
                            <Form.Item
                                label="Credit Limit Approval Status"
                                name="credit_limit_approval_status"
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Sub Total" name="sub_total">
                                <InputNumber

                                    style={{ width: '100%' }}
                                    formatter={(value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                                    parser={(value) => value ? value.replace(/\$\s?|(,*)/g, '') : ''}
                                    readOnly
                                />
                            </Form.Item>
                            <Form.Item label="Item Discount" name="item_disc">
                                <InputNumber

                                    style={{ width: '100%' }}
                                    formatter={(value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                                    parser={(value) => value ? value.replace(/\$\s?|(,*)/g, '') : ''}
                                    readOnly
                                />
                            </Form.Item>
                            <Form.Item label="Total" name="total_a">
                                <InputNumber

                                    style={{ width: '100%' }}
                                    formatter={(value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                                    parser={(value) => value ? value.replace(/\$\s?|(,*)/g, '') : ''}
                                    readOnly
                                />
                            </Form.Item>
                            <Form.Item
                                label="VAT"
                                name="vat"
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    formatter={(value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                                    parser={(value) => value ? value.replace(/\$\s?|(,*)/g, '') : ''}
                                    readOnly
                                />
                            </Form.Item>
                            <Form.Item
                                label="Grand Total"
                                name="grand_total"
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    formatter={(value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                                    parser={(value) => value ? value.replace(/\$\s?|(,*)/g, '') : ''}
                                    readOnly
                                />
                            </Form.Item>
                        </Form>
                    </div>
                    <div className="gjs-grid-column" id="ivfks">
                        <Form
                            form={form}
                            onValuesChange={handleFormChange}
                            layout="horizontal"
                            style={{ maxWidth: 550, paddingTop: '20px' }}
                            labelCol={{ style: { width: '200px' } }}
                            wrapperCol={{ style: { width: '290px' } }}
                            className="custom-info-so_next4"

                        >
                            <Form.Item
                                label="Remark"
                                name="remark"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Required!',
                                    },
                                ]}
                            >
                                <Input.TextArea placeholder="Enter your remark" rows={2} />
                            </Form.Item>
                            <Form.Item
                                label="Credit Limit Remaining"
                                name="credit_limit_remaining"
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Sales Name" name="sales_person" initialValue={userData?.nama}>
                                <Input className="input-detail-cs" placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="User Approved" name="user_approved">
                                <Input className="input-detail-cs" placeholder="" readOnly />
                            </Form.Item>
                        </Form>
                    </div>
                </div>

                {/* Row 4 */}
                <div className="gjs-grid-row" id="ihjb">
                    <div className="gjs-grid-column" id="i4vh">
                        <br></br>
                        <br></br>
                        <Button className="green-button" onClick={handleAddLineModalOpen} disabled={!isStatus01()}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                                <path
                                    fillRule="evenodd"
                                    d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V12Z"
                                    clipRule="evenodd"
                                />
                                <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                            </svg>
                            Add Line
                        </Button>
                        <Button className="green-button" onClick={handleDelete} disabled={selectedRowKeys.length === 0}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                                <path
                                    fillRule="evenodd"
                                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            Delete ({selectedRowKeys.length})
                        </Button>
                        <Button className="green-button" disabled={!isStatus01()}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                                <path
                                    fillRule="evenodd"
                                    d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                    clipRule="evenodd"
                                />
                                <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                            </svg>
                            Upload
                        </Button>
                        <Button className="green-button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                                <path d="M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z" />
                                <path
                                    fillRule="evenodd"
                                    d="m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087ZM12 10.5a.75.75 0 0 1 .75.75v4.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72v-4.94a.75.75 0 0 1 .75-.75Z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            Download Template
                        </Button>
                        <Button className="green-button" onClick={handleLockItem} disabled={isLockItemDisabled}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                                <path d="M2.25 2.25a.75.75 0 0 0 0 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 0 0-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 0 0 0-1.5H5.378A2.25 2.25 0 0 1 7.5 15h11.218a.75.75 0 0 0 .674-.421 60.358 60.358 0 0 0 2.96-7.228.75.75 0 0 0-.525-.965A60.864 60.864 0 0 0 5.68 4.509l-.232-.867A1.875 1.875 0 0 0 3.636 2.25H2.25ZM3.75 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM16.5 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" />
                            </svg>
                            Lock Item
                        </Button>
                        <br></br>
                        <br></br>
                        <div style={{ overflowX: 'auto' }}>
                            <Table<SalesMasterData>
                                rowSelection={rowSelection}
                                columns={columns}
                                dataSource={tableData}
                                scroll={{ x: 1200 }}
                                onRow={(record) => ({
                                    onDoubleClick: () => handleRowDoubleClick(record)
                                })}
                            />
                            {error && <div style={{ color: 'red' }}>{error instanceof Error ? error.message : String(error)}</div>}
                        </div>
                    </div>
                </div>
            </div>
        </Spin>
    );
};

export default SalesEstimation;